<template>
    <transition name="slide-and-fade">
        <div class="flash_message_wrapper" v-show="active">
            <div class="flash_message" :class="type">
              <button class="close" type="button" @click="active = false">
                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
                  <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path>
                </svg>
              </button>
              <p>{{ message | tidyMessage }}</p>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        message: {
            required: true,
            type: String,
        },
        type: {
            required: true,
            type: String
        }
    },
    data(){
      return {
        active: true
      }
    },
    mounted(){
      setTimeout(() => {
         this.active = false;
      }, 8000);
    },
    filters: {
      tidyMessage(message) {
        if (message == 'User saved.') { return 'Your profile has been updated.'; }
        return message;
      }
    }
}
</script>